<template>
    <div class="flex relative my-auto container mx-auto">

      <div class="subsection-big-circle flex flex-col bg-black rounded-full mx-auto">
        <h1 class="deep-info-sub-heading text-white mx-auto pt-20 text-2xl font-bold leading-tight">ART PRODUCTION <br> PROCESS & COSTS</h1>

        <img src="https://blissing.s3-us-west-1.amazonaws.com/img/pdf-images/Art+Production+Process+%26+Costs.png" alt="pdf image"
        class="mx-auto cursor-pointer" @click="showPdf()">

      </div>

      <NextArrow next="sub-concept-two"/>

    </div>
</template>

<script>
import NextArrow from "@/components/deepinfo/subnavigation/NextArrow.vue";

export default {
  name: "ConceptSubOne",
  props:{
    pdfUrl:{
      required: true,
      type: String,
    }
  },
  components:{
    NextArrow
  },
  methods:{
    showPdf(){
      // Event.$emit('openPdf', pdf);
      window.open(this.pdfUrl);
    }
  }
}
</script>
